module.exports = __webpack_public_path__ + "static/img/zzjg.29d9c26.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zzjg.png
// module id = YHV/
// module chunks = 1